import { Alert, Button, Col, message, Modal, Row } from 'antd';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import Home from './components/Home';
import './style/global.css';
import './style/home.css';

// console.log(
//   "%c Test version.\n Change package.json 'home' to real link",
//   'color: #ff0000; font-size: 30px;'
// );

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      left: false,
      right: false,
      loading: true, //Set to true after testing!! FIXME
      projectsOldFields: []
    };
    this.toggleLeft = this.toggleLeft.bind(this);
    this.toggleRight = this.toggleRight.bind(this);
    this.handleScrollToElement = this.handleScrollToElement.bind(this);
    this.setIsLoading = this.setIsLoading.bind(this);
    this.setCovidModalVisible = this.setCovidModalVisible.bind(this);
  }

  async componentDidMount() {
    setTimeout(() => this.setCovidModalVisible(true), 2000); //FIXME re-enable after changes
  }

  setCovidModalVisible(covidModalVisible) {
    this.setState({ covidModalVisible });
  }
  setIsLoading(isLoading) {
    this.setState({ loading: isLoading });
  }

  toggleLeft() {
    this.setIsLoading(true);
    this.setState({ left: !this.state.left });
  }

  toggleRight() {
    this.setIsLoading(true);
    this.setState({ right: !this.state.right });
  }

  render() {
    return (
      <div className="App">
        <Row style={{ height: '100vh' }}>
          {/* <Col xs={{ span: 2 }} lg={{ span: 1 }}>
            <Affix>
              <div className="divLeft">
                <a>
                  <img
                    className="pageStickLeft"
                    onClick={() => this.toggleLeft()}
                    src={pushArquivo}
                    alt="pagesticker"
                  />{" "}
                </a>
              </div>
            </Affix>
          </Col> */}

          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Home
              //left={this.state.left}
              right={true} //changed for COVID screen always ON
              toggleLeft={this.toggleLeft}
              toggleRight={this.toggleRight}
              setIsLoading={this.setIsLoading}
              isLoading={this.state.loading}
              projectFromDB={this.state.projectsOldFields}
            />
            <Modal
              destroyOnClose={true}
              closable={true}
              cancelButtonProps={{ visible: false }}
              title={'Rede Resposta BIP/ZIP COVID 19'}
              wrapClassName="vertical-center-modal"
              visible={this.state.covidModalVisible}
              okText="Fechar"
              //onOk={() => this.setcovidModalVisible(false)}
              onCancel={() => this.setCovidModalVisible(false)}
              footer={[
                <Button
                  key="ok"
                  onClick={() => this.setCovidModalVisible(false)}
                >
                  Fechar
                </Button>
              ]}
              //cancelText={"Imprimir"}
              //onCancel={() => window.print()}
              width="90%"
            >
              <Alert
                message="A informação apresentada foi disponibilizada pelas próprias
                entidades e será actualizada de acordo com a evolução das
                iniciativas locais."
                type="error"
              />
              {/* <div className="text" style={{backgroundColor:"#"}}>
                A informação apresentada foi disponibilizada pelas próprias
                entidades e será actualizada de acordo com a evolução das
                iniciativas locais.{" "}
              </div> */}
              <br />
              <br />
              <div
                style={{ fontFamily: 'Work Sans', fontSize: 15, color: '#000' }}
              >
                Covid 19 - Resposta solidária à crise <br /> <br />
                Isolamento físico não é isolamento social <br /> <br />
                <div
                  style={{
                    fontFamily: 'Work Sans',
                    fontSize: 15,
                    fontWeight: 700,
                    color: '#000'
                  }}
                >
                  Mapa BIPZIP: Energia em acção nos territórios{' '}
                </div>{' '}
                <br />
                Num momento em que nos pedem confinamento e isolamento físico, a
                solidariedade e as redes de contacto de apoio às comunidades são
                o caminho a seguir. <br /> Assim, o Fórum Urbano e o Pelouro da
                Habitação e Desenvolvimento Local, juntaram esforços e criámos
                este mapa interativo dos projectos BIPZIP que têm actividades de
                combate à pandemia e apoio solidário à população. Acresce a rede
                de Associações de Moradores no Mercado Solidário. A resposta à
                crise pandémica que vivemos pode ter muitas formas:
                <br />
                • Apoio psicológico
                <br />
                • Informação sobre os nossos direitos
                <br />• Construção de redes de apoio
                <br />• Distribuição de alimentação
                <br />
                • Produção de material hospitalar
                <br />
                • Respostas culturais
                <br />
                Todas elas tão necessárias. A Energia BIPZIP não podia deixar de
                actuar, na resposta social, no desenvolvimento local em cada
                território.
                <br /> <br />
                Veja aqui todos os serviços e projectos que temos para si.
                <br /> <br />
                <div
                  style={{
                    fontFamily: 'Work Sans',
                    fontSize: 15,
                    fontWeight: 700,
                    color: '#000'
                  }}
                >
                  Juntos somos mais fortes.
                </div>
                <br /> <br />
                Paula Marques
                <br />
                Vereadora da Habitação e Desenvolvimento Local <br />
                <br />
                Locals Approach <br />
                Forum Urbano
              </div>{' '}
            </Modal>
          </Col>
        </Row>
      </div>
    );
  }

  handleScrollToElement() {
    const tesNode = ReactDOM.findDOMNode(this.refs.sobre_page);

    window.scrollTo(0, tesNode.offsetTop);
  }

  handleChange(date) {
    message.info('Selected Date: ' + (date ? date.toString() : ''));
    this.setState({ date });
  }
}

export default App;
